import React, { useState } from 'react'
import { useTranslate, required, Form } from 'react-admin'
import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { Grid } from '@mui/material'
import { Dialog, DialogContent, DialogTitle, DialogActions, Box, Button, Tooltip, Icon } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
export const ReAssignModalSeller = ({
  open,
  handleClose,
  titleModal,
  actionButtonLoading,
  onClickButton,
  avoid = ['created_at', 'updated_at', 'all_devices', 'language', 'is_hidden'],
  onSubmitCustom,
}) => {
  const translate = useTranslate()
  const [usersList, setUserList] = useState([])
  const [user, setUser] = useState({})
  const [usersLoading, setLoadingUserList] = useState(false)

  const { cardId } = useCardId()

  const onSubmit = (data) => {
    onSubmitCustom && onSubmitCustom(data, cardId)
    handleCloseModal()
  }

  const hadId = (str) => {
    return str.includes('_id') || str.includes('id_')
  }

  let searchTimeout
  const getUserB2 = async (user, length = 2) => {
    clearTimeout(searchTimeout)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      setUserList([])
      return
    }

    searchTimeout = setTimeout(async () => {
      try {
        setLoadingUserList(true)
        let filter = {
          limit: 20
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        setUserList(allUser)
      } catch (error) {
        setUserList([])
      } finally {
        setLoadingUserList(false)
      }
    }, 1000)
  }

  const resetForm = () => {
    setUserList([]) // Resetea la lista de usuarios
    setUser({}) // Resetea el usuario seleccionado
  }

  const handleCloseModal = () => {
    resetForm()
    handleClose()
  }

  const setUserSelected = (value) => {
    try {
      if (!value){
        setUser(null)
      }else {
        setUser(value)
      }
    } catch (error) {
      setUser(null)
    }
  }

  return (
    <Dialog open={open} maxWidth='md' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>

      <DialogContent>
        <Form id='post_create_form' onSubmit={onSubmit}>
          <Grid container item marginTop={'10px'}>
            <Box display='flex' alignItems='center'>
              <EditInputsWrap lg={12} md={12} xs={12}>
                <MultiAutocompleteInput
                  source='choice'
                  options={usersList}
                  loading={usersLoading}
                  optionsText={['firstname', 'surname']}
                  optionValue='id'
                  onSearch={getUserB2}
                  resetOnLoad={false}
                  fields={['firstname', 'surname']}
                  validate={[required()]}
                  onChange={(e) => setUserSelected(e?.target?.value)}
                  disablePortal={false}
                />
              </EditInputsWrap>
              <Tooltip
                title={translate('ra.message.valid_characters', { num: 2 })}
                className='tooltip'
                placement='top'
              >
                <Icon sx={{ color: '#5663c9d1', fontSize: 14, paddingBottom: 20 }}>info</Icon>
              </Tooltip>
            </Box>
          </Grid>
        </Form>
        <Grid container spacing={3} sx={{ marginTop: '20px', padding: '20px' }}>
          {user &&
            Object.keys(user || {}).map((prop, i) => {
              if (
                !Array.isArray(user?.[prop]) &&
                typeof user?.[prop] !== 'object' &&
                avoid &&
                !avoid.includes(prop) &&
                !hadId(prop)
              ) {
                return (
                  <ShowListElement
                    key={i}
                    label={translate(`ra.field.${prop}`)}
                    value={user?.[prop]}
                    type={typeof user?.[prop] === 'boolean' ? 'boolean' : ''}
                  />
                )
              }
              return null
            })}
        </Grid>
        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={actionButtonLoading}
            variant='contained'
            onClick={onClickButton}
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button onClick={handleCloseModal} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
